
export default {
	discordMain: 'https://discord.gg/nw3Ad2c',
	discordModding: 'https://discord.gg/8dqM6xDmrC',
	discordModdingBugReportInvite: 'https://discord.gg/hGRFS7fPyT',
	discordModdingBugReportChannel: 'https://discord.com/channels/790357117511925771/790357714966282280',
}
